import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Card, Button, Row, Col, Form, Modal } from "react-bootstrap";

const Pacientes = ({ setSelectedPaciente, setActiveSection })  => {
    const [pacientes, setPacientes] = useState([]);
    const [error, setError] = useState(null);
    const [dni, setDni] = useState('');
    const [nombre, setNombre] = useState('');
    const [selectedPacienteLocal, setSelectedPacienteLocal] = useState(null);
    const [consultas, setConsultas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showNewPacienteModal, setShowNewPacienteModal] = useState(false);
    const [showEditPacienteModal, setShowEditPacienteModal] = useState(false);
    const [showDeletePacienteModal, setShowDeletePacienteModal] = useState(false);
    const [historialesDni, setHistorialesDni] = useState(new Set());
    const pacienteVacio = { dni_paciente: '', nombre_paciente: '', correo: '', telefono: '', domicilio: '' };
    const [newPaciente, setNewPaciente] = useState(pacienteVacio);
    const [editPaciente, setEditPaciente] = useState(pacienteVacio);

    useEffect(() => {
        fetchPacientes();
    }, []);

    useEffect(() => {
        if (nombre.trim() !== '') {
            const timer = setTimeout(handleSearchByName, 300);
            return () => clearTimeout(timer);
        } else {
            fetchPacientes();
        }
    }, [nombre]);
    
    const mapPacientesConHistorial = (pacientesData, dnisConHistorial) =>
        pacientesData.map((paciente) => ({
            ...paciente,
            tieneHistorial: dnisConHistorial.has(String(paciente.dni_paciente)),
        }));

    const fetchPacientes = async () => {
        try {
            const [pacientesRes, historialesRes] = await Promise.all([
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/`),
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales`),
            ]);

            const dnisConHistorial = new Set(
                (historialesRes.data || []).map((historial) => String(historial.dni_paciente))
            );

            setHistorialesDni(dnisConHistorial);
            setPacientes(mapPacientesConHistorial(pacientesRes.data || [], dnisConHistorial));
            setError(null);
        } catch {
            setError('Error al obtener los pacientes');
        }
    };

      const handleSearchByDni = () => {
        if (!dni.trim()) {
          return fetchPacientes();
        }
      
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/dni/${dni}`)
          .then(response => {
            const paciente = response.data;
            return {
                ...paciente,
                tieneHistorial: historialesDni.has(String(paciente.dni_paciente)),
            };
          })
          .then(pacienteConHistorial => {
            setPacientes([pacienteConHistorial]);
            setError(null);
          })
          .catch(err => {
            // Si la API devolvió 404, mostramos “no se encontró”
            if (err.response?.status === 404) {
              setError(`No se encontró un paciente con el DNI ${dni}.`);
            } else {
              setError(`Error al buscar el paciente con DNI ${dni}.`);
            }
          });
      };
      

    const handleSearchByName = () => {
        if (nombre.trim() !== '') {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/pacientes/nombre/${nombre}`)
                .then(response => {
                    if (response.data.length > 0) {
                        const pacientesData = response.data;
                        setPacientes(mapPacientesConHistorial(pacientesData, historialesDni));
                        setError(null);
                    } else {
                        setError(`No se encontraron pacientes con el nombre "${nombre}".`);
                    }
                })
                .catch(() => setError(`Error al buscar pacientes con el nombre "${nombre}".`));
        } else {
            fetchPacientes();
        }
    };

    const handleViewConsultas = (paciente) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/consultas/paciente/${paciente.dni_paciente}`)
            .then(response => {
                setConsultas(response.data);
                setSelectedPacienteLocal(paciente);
                setShowModal(true);
            })
            .catch(() => setError('El paciente no posee consultas'));
    };

    const handleCheckOrCreateHistorial = (paciente) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/historiales/${paciente.dni_paciente}`)
            .then(response => {
                if (response.data) {
                    alert('La historia clínica ya existe');
                } else {
                    createHistorial(paciente.dni_paciente);
                }
            })
            .catch(() => {
                createHistorial(paciente.dni_paciente);
            });
    };

    const createHistorial = (dni_paciente) => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/historiales/`, { dni_paciente })
            .then(() => {
                setShowSuccessModal(true);
            })
            .catch(() => setError('Error al crear la historia clínica'));
    };

    const handleAddPaciente = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/pacientes`, newPaciente)
            .then(() => {
                setShowNewPacienteModal(false);
                setNewPaciente(pacienteVacio);
                fetchPacientes();
            })
            .catch(() => setError('Error al agregar el paciente'));
    };

    const handleEditPaciente = () => {
        axios.put(`${process.env.REACT_APP_BACKEND_URL}/pacientes/${editPaciente.dni_paciente}`, editPaciente)
            .then(() => {
                setShowEditPacienteModal(false);
                fetchPacientes();
            })
            .catch(() => setError('Error al editar el paciente'));
    };

    const handleDeletePaciente = () => {
        axios.delete(`${process.env.REACT_APP_BACKEND_URL}/pacientes/${selectedPacienteLocal.dni_paciente}`)
            .then(() => {
                setShowDeletePacienteModal(false);
                fetchPacientes();
            })
            .catch(() => setError('Error al eliminar el paciente'));
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPacienteLocal(null);
        setConsultas([]);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        fetchPacientes();
    };

    const handleOpenWhatsApp = (telefono) => {
        window.open(`https://wa.me/${telefono}`, '_blank');
    };

     const handleOpenHistorial = (paciente) => {
       // Le decimos al padre qué paciente mostrar…
       setSelectedPaciente(paciente.dni_paciente);
           // …y navegamos a la sección de historial
          setActiveSection("PacienteHistorial");
         };
    return (
        <Container fluid className="bg-light min-vh-100 p-4">
            <h2 className="text-center mb-4">Gestión de Pacientes</h2>

            {error && (
                <div className="alert alert-danger d-flex justify-content-between align-items-center">
                    <span>{error}</span>
                    <Button variant="outline-danger" size="sm" onClick={() => setError(null)}>
                        &times;
                    </Button>
                </div>
            )}

            <Row className="mb-4 g-2 justify-content-center">
                <Col xs={12} md={5} className="mb-2">
                    <Form.Control
                        type="text"
                        placeholder="Buscar por DNI"
                        value={dni}
                        onChange={(e) => setDni(e.target.value)}
                    />
                </Col>
                <Col xs="auto" className="mb-2">
                    <Button variant="primary" onClick={handleSearchByDni}>Buscar</Button>
                </Col>

                <Col xs={12} md={5} className="mb-2">
                    <Form.Control
                        type="text"
                        placeholder="Buscar por Nombre"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                </Col>
                <Col xs="auto" className="mb-2">
                    <Button variant="primary" onClick={handleSearchByName}>Buscar</Button>
                </Col>
            </Row>

            <Button variant="success d-flex justify-content-center" className="mb-4" onClick={() => setShowNewPacienteModal(true)}>Nuevo Paciente</Button>

            <Row className="g-3">
    {pacientes.length > 0 ? (
        pacientes.map((paciente, index) => (
            <Col xs={12} md={6} lg={4} key={index}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <Card.Title>{paciente.nombre_paciente}</Card.Title>
                        <Card.Text>
                            <strong>DNI:</strong> {paciente.dni_paciente ?? ''} <br />
                            <strong>Correo:</strong> {paciente.correo ?? ''} <br />
                            <strong>Teléfono:</strong> {paciente.telefono ?? ''}<br />
                            <strong>Domicilio:</strong> {paciente.domicilio || ''}<br /> 
                        </Card.Text>
                        <Container>
                            {/* Primera Fila: 3 Botones */}
                            <Row>
    <Col xs={paciente.tieneHistorial ? 4 : 4} md={paciente.tieneHistorial ? 4 : 4} lg={paciente.tieneHistorial ? 4 : 4} className="d-grid"> 
        <Button variant="primary" className="btn-responsive" onClick={() => handleViewConsultas(paciente)}>
            Historial de consultas
        </Button>
    </Col>
    
     {paciente.tieneHistorial ? (
   <Col xs={4} md={4} lg={4} className="d-grid">
    <Button
       variant="info"
     className="btn-responsive"
     onClick={() => handleOpenHistorial(paciente)}
    >
      Abrir Historia Clínica
    </Button>
   </Col>
 ) : (
   <Col xs={4} md={4} lg={4} className="d-grid">
    <Button
      variant="secondary"
      className="btn-responsive"
             onClick={() => handleCheckOrCreateHistorial(paciente)}
     >
       Crear Historia Clínica
     </Button>
   </Col>
 )}

    <Col xs={paciente.tieneHistorial ? 4 : 4} md={paciente.tieneHistorial ? 4 : 4} lg={paciente.tieneHistorial ? 4 : 4} className="d-grid">
        <Button variant="warning" className="btn-responsive" onClick={() => {
            setEditPaciente(paciente);
            setShowEditPacienteModal(true);
        }}>
            Editar
        </Button>
    </Col>
</Row>


                            {/* Segunda Fila: 2 Botones */}
                            <Row>
                                <Col xs={6} md={6} lg={6} className="d-grid">
                                    <Button variant="danger" className="btn-responsive" onClick={() => {
                                        setSelectedPacienteLocal(paciente);
                                        setShowDeletePacienteModal(true);
                                    }}>
                                        Eliminar
                                    </Button>
                                </Col>
                                <Col xs={6} md={6} lg={6} className="d-grid">
                                    <Button variant="success" className="btn-responsive" onClick={() => handleOpenWhatsApp(paciente.telefono)}>
                                        Abrir WhatsApp
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>
            </Col>
                    ))
                ) : (
                    <Col xs={12}>
                        <p className="text-center">No hay pacientes registrados.</p>
                    </Col>
                )}
            </Row>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Historial de {selectedPacienteLocal?.nombre_paciente}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {consultas.length > 0 ? (
                        consultas.map((consulta, index) => (
                            <Card key={index} className="mb-2 shadow-sm">
                                <Card.Body>
                                    <p>
                                        <strong>Fecha:</strong> {consulta.Horario?.fecha || "N/A"} <br />
                                        <strong>Hora:</strong> {consulta.Horario?.hora || "N/A"} <br />
                                        <strong>Descripción:</strong> {consulta.descripcion || "N/A"} <br />
                                        <strong>Odontóloga:</strong> {consulta.Horario?.odontologa?.nombre || "N/A"}
                                    </p>
                                </Card.Body>
                            </Card>
                        ))
                    ) : (
                        <p className="text-center">No hay consultas registradas.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSuccessModal} onHide={handleCloseSuccessModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Éxito</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Historia clínica creada exitosamente.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleCloseSuccessModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showNewPacienteModal} onHide={() => setShowNewPacienteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Nuevo Paciente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>DNI</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese DNI"
                                value={newPaciente.dni_paciente}
                                onChange={(e) => setNewPaciente({ ...newPaciente, dni_paciente: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Nombre"
                                value={newPaciente.nombre_paciente}
                                onChange={(e) => setNewPaciente({ ...newPaciente, nombre_paciente: e.target.value })}
                            />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Teléfono"
                                value={newPaciente.telefono}
                                onChange={(e) => setNewPaciente({ ...newPaciente, telefono: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Domicilio</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Domicilio"
                                value={newPaciente.domicilio}
                                onChange={(e) => setNewPaciente({ ...newPaciente, domicilio: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowNewPacienteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleAddPaciente}>
                        Agregar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditPacienteModal} onHide={() => setShowEditPacienteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Paciente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>DNI</Form.Label>
                            <Form.Control
                                type="text"
                                value={editPaciente.dni_paciente}
                                readOnly
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Nombre"
                                value={editPaciente.nombre_paciente}
                                onChange={(e) => setEditPaciente({ ...editPaciente, nombre_paciente: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Correo</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Ingrese Correo"
                                value={editPaciente.correo}
                                onChange={(e) => setEditPaciente({ ...editPaciente, correo: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Teléfono"
                                value={editPaciente.telefono}
                                onChange={(e) => setEditPaciente({ ...editPaciente, telefono: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Domicilio</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ingrese Domicilio"
                                value={editPaciente.domicilio || ''}
                                onChange={(e) => setEditPaciente({ ...editPaciente, domicilio: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditPacienteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleEditPaciente}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeletePacienteModal} onHide={() => setShowDeletePacienteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar Paciente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Estás seguro de que deseas eliminar al paciente {selectedPacienteLocal?.nombre_paciente}? Esto borrará la historia clínica y la información no es recuperable</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeletePacienteModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleDeletePaciente}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Pacientes;

/*
                        <Form.Group className="mb-3">
                            <Form.Label>Correo</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Ingrese Correo"
                                value={newPaciente.correo}
                                onChange={(e) => setNewPaciente({ ...newPaciente, correo: e.target.value })}
                            />
                        </Form.Group>*/
